export enum GlAccountsListTabsEnum {
  ACCOUNTS = 'accounts',
  TRANSACTIONS = 'transactions',
}
